import { ITheme } from '../../../../../ui';
import { IFlightPublicStatus } from '../domain/models/IFlightPublicStatus';
import { Color } from '../../../../shared/styles/Color';

export function getColorForFlightStatus(
	status: IFlightPublicStatus,
	theme: ITheme,
) {
	switch (status) {
		case 'Arrived':
			return '#01426A';

		case 'Arriving':
			return '#0077C8';

		case 'Boarding':
			return '#981D97';

		case 'Cancelled':
			return `${Color.ErrorDark}`;

		case 'Canceled':
			return `${Color.ErrorDark}`;

		case 'Closed':
			return '#01426A';

		case 'Departed':
			return '#01426A';

		case 'Delayed':
			return '#00778B';

		case 'Landed':
			return '#01426A';

		case 'On Time':
			return '#0077C8';

		default:
			return theme.color.highlight;
	}
}
